export default "__VITE_ASSET__DxDrf1Zf__";